export default __webpack_public_path__ + "static/media/markerFinish.b5d6f0cb.svg";